module.exports = __webpack_public_path__ + "static/adsa-18-8682b2c1d9825fe7e687db1a50013dcf.png";